export enum EmailSubscriptionType {
  INVALID = 0,
  NEWSLETTER = 1,
  SIZE_REMINDER = 2,
  WISHLIST_BASKET = 3,
  RECOMMENDATIONS = 4,
  RATING = 5,
  EMAIL_SUBSCRIPTION_HOT_DROPS_SNEAKER = 6,
  EMAIL_SUBSCRIPTION_HOT_DROPS_AY_LABEL = 7,
  // Subscription type for all individual drop subscription
  // While one can subscribe for individual drops, one can only unsubscribe from all such notifications in bulk
  EMAIL_SUBSCRIPTION_HOT_DROPS_INDIVIDUAL = 8,
}

export interface EmailSubscriptions {
  isEmailConfirmationPending: boolean;
  subscriptions: EmailSubscriptions_EmailSubscription[];
}

export interface EmailSubscriptions_EmailSubscription {
  type: EmailSubscriptionType;
  isSelected: boolean;
}
